import { render } from "./SeoImagesCountCell.vue?vue&type=template&id=4889c720&scoped=true"
import script from "./SeoImagesCountCell.vue?vue&type=script&lang=js"
export * from "./SeoImagesCountCell.vue?vue&type=script&lang=js"

import "./SeoImagesCountCell.vue?vue&type=style&index=0&id=4889c720&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4889c720"]])

export default __exports__